import $ from "jquery";

const GRECAPTCHA_EL = ".g-recaptcha";
const GRECAPTCHA_RESPONSE_EL = ".g-recaptcha-response";
const FORM_SUBMIT_PLEASE_CLASS = "submit-please";
const FORM_SUBMIT_PLEASE_EL = `.${FORM_SUBMIT_PLEASE_CLASS}`;

const $gRecaptchaEl = $(GRECAPTCHA_EL);

if ($gRecaptchaEl.length > 0) {
  grecaptcha.ready(() => {
    $gRecaptchaEl.each(function () {
      let executed = false;
      const form = $gRecaptchaEl.closest("form");

      grecaptcha.render($(this)[0]);
      form.on("submit", function (e) {
        if (executed) {
          return;
        }

        e.preventDefault();
        grecaptcha.execute().then(() => {
          executed = true;
        });
        form.addClass(FORM_SUBMIT_PLEASE_CLASS);
      });
    });
  });
}

window.recaptchaFormListener = (token) => {
  const $gRecaptchaResponseEL = $(GRECAPTCHA_RESPONSE_EL);
  if ($gRecaptchaResponseEL.length > 0) {
    $gRecaptchaResponseEL.each(function () {
      $(this).val(token);
    });
  }

  const $forms = $(FORM_SUBMIT_PLEASE_EL);
  if ($forms.length > 0) {
    $forms.each(function () {
      $(this).submit();
    });
  }
};
